import { createFileRoute } from '@tanstack/react-router';
import ProvidedJobPostDetailTemplate from '@/features/agent/provided_job_posts/templates/ProvidedJobPostDetailTemplate';

export const Route = createFileRoute('/agent/provided_job_posts/$providedJobPostsId/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { providedJobPostsId } = Route.useParams();
  return <ProvidedJobPostDetailTemplate id={providedJobPostsId} />;
}
